// frontend/libs/db/src/models/certificates.ts

import { SyncRecordStatus } from '../types/sync-state';

export type VendorType = 'OXBRIDGE' | 'BEACONHOUSE' | 'TALEEMABAD' | 'NIETE' | 'I_SAPS';

export interface CertificateMetadata {
  issuer: string; // "Oxbridge Innovative Solutions (Pvt.) Ltd."
  signatory: string; // "Manzil e Maqsood"
  title: string; // "CEO"
  colors?: {
    primary: string;
    secondary: string;
  };
  logoUrl?: string;
}

export interface Certificate {
  // IDs
  id: string; // UUID from backend
  participant?: string; // User ID (optional, from dual FK pattern)
  profile?: string; // UUID string (not the numeric SyncRecord.profile)
  course: string; // Course ID
  assessment?: string; // Assessment ID (optional, from backend)
  vendor: VendorType;

  // Display fields (snapshots from when issued)
  teacherName: string;
  trainingName: string;
  completionDate: string; // ISO YYYY-MM-DD
  issuedAt: string; // ISO timestamp

  // Unique identifier
  certificateCode: string; // OX-YYYYMMDDHHMM-XXXXXX

  // Metadata for rendering
  metadata: CertificateMetadata;

  // Sync & audit
  syncStatus: SyncRecordStatus;
  modifiedAt?: string; // ISO timestamp
  isActive: boolean;
}

export const VENDOR_CODE_PREFIXES: Record<VendorType, string> = {
  OXBRIDGE: 'OX',
  BEACONHOUSE: 'BC',
  TALEEMABAD: 'TL',
  NIETE: 'NI',
  I_SAPS: 'IS',
};

export const OXBRIDGE_METADATA_DEFAULTS: CertificateMetadata = {
  issuer: 'Oxbridge Innovative Solutions (Pvt.) Ltd.',
  signatory: 'Manzil e Maqsood',
  title: 'CEO',
  colors: {
    primary: '#003366',
    secondary: '#FFD700',
  },
  // logoUrl is set at runtime via the OxbridgeLevelCertificate component import
  // which handles the static PNG asset via the DSM layer.
  logoUrl: 'oxbridge',
};

export const BEACONHOUSE_METADATA_DEFAULTS: CertificateMetadata = {
  issuer: 'Beaconhouse',
  signatory: 'Director',
  title: 'Director',
  colors: {
    primary: '#1F4788',
    secondary: '#FDB913',
  },
  logoUrl: undefined,
};

export const I_SAPS_METADATA_DEFAULTS: CertificateMetadata = {
  issuer: 'I-SAPS',
  signatory: '',
  title: '',
  logoUrl: undefined,
};
